<template>
  <div class="m-wrap-material">
    <div class="box-inline">
      <Button type="primary" :disabled="disabled" @click="selectMaterial(type)">选择{{ typeName }}</Button>
      <span class="span-num"
        ><ins>{{ value.length }}</ins
        >/{{ max }}</span
      >
      <Poptip v-if="value.length && !disabled" confirm title="确定要清空？" class="pop-btn" @on-ok="$emit('on-clear')">
        <Icon type="ios-trash-outline" size="22" color="#ff2200" />
        <span>清空全部</span>
      </Poptip>
    </div>

    <div v-if="len" class="m-creative">
      <creative
        v-if="type === 'video'"
        type="video"
        :data="value"
        :words="words"
        :title="false"
        :local="false"
        @on-select="selectVideo"
        @on-delete="deleteItem"
      />
      <creative
        v-if="type === 'large'"
        type="large"
        :data="value"
        :words="words"
        :title="false"
        :local="false"
        @on-select="selectImage"
        @on-delete="deleteItem"
      />
    </div>
    <div v-else class="c-nodata">
      <Icon type="ios-filing-outline" size="92" color="#efefef" />
      <span>请选择{{ typeName }}</span>
    </div>

    <uploader
      v-model="creativeModel"
      :multiple="creativeMult"
      :type="creativeType"
      :media="media"
      :smart="creativeSmart"
      :default-option="gameId"
      @on-upload="uploadFileHandler"
    />
  </div>
</template>
<script>
import { timeout, isArray } from '@/common/js/utils'

import Uploader from '@/views/create/toutiao_local/components/idea/uploader.vue'
import Creative from '@/views/create/toutiao_local/components/idea/creative/creative.vue'

import { setImageCoverId } from '@/api/material.model'
export default {
  name: 'MaterSelect',
  components: { Uploader, Creative },
  props: {
    value: {
      type: Array
    },
    max: {
      type: Number
    },
    gameId: {
      type: [Number, String]
    },
    media: {
      type: [Number, String]
    },
    words: {
      type: Array
    },
    disabled: {
      type: Boolean
    },
    type: {
      type: String
    }
  },
  computed: {
    len() {
      return this.value.length
    },
    typeName() {
      if (this.type === 'video') return '视频'
      else if (this.type === 'large') return '图片'
      else return ''
    }
  },
  methods: {
    // 选择素材
    selectMaterial(type) {
      this.creativeType = type
      this.creativeMult = true
      this.creativeSmart = 0
      this.creativeModel = true
    },
    editMaterial(id) {
      this.creativeModel = true
      this.creativeSmart = id
    },
    // 更新素材
    selectVideo(params) {
      const { index } = params
      if (isArray(index)) {
        // 封面
        const [idx] = index
        const { id: smart, width, height } = this.value[idx].children[0]
        this.creativeIndex = idx // index
        this.creativeType = 'large'
        this.creativeMult = false
        this.creativeSmart = smart
        this.creativeWidth = width
        this.creativeHeight = height
        this.creativeModel = true
      } else {
        // 视频
        this.creativeType = 'video'
        this.creativeMult = false
        this.creativeSmart = 0
        this.creativeModel = true
      }
    },
    selectImage(params) {
      const { index } = params
      if (index || index === 0) {
        const { width, height } = this.value[index]
        this.creativeIndex = index // index
        this.creativeWidth = width
        this.creativeHeight = height
      } else {
      }
      this.creativeType = 'large'
      this.creativeMult = false
      this.creativeSmart = 0
      this.creativeModel = true
    },
    deleteItem({ type, index }) {
      this.$emit('on-delete', index)
    },
    uploadFileHandler(meta) {
      if (this.creativeMult) {
        // 批量添加进来
        this.$emit('on-select', meta)
        timeout(0).then(() => {
          this.creativeModel = false
        })
      } else if (this.creativeType === 'large' && this.type === 'video') {
        // 封面
        if (!isArray(meta)) return
        const cover = meta.pop()
        const { id, cover_url, url, width, height } = cover
        if (this.creativeWidth !== width || this.creativeHeight !== height) {
          this.$Message.error(`选择的图片尺寸不对，请选择 ${this.creativeWidth} x ${this.creativeHeight}`)
          return
        }
        setImageCoverId({
          detailId: this.creativeSmart,
          coverId: id,
          addr: cover_url || url
        }).then((data) => {
          if (data) {
            this.$emit('on-replace', { index: this.creativeIndex, item: [cover] })
            timeout(0).then(() => {
              this.creativeModel = false
            })
          }
        })
      } else if (this.creativeType === 'video') {
        // 视频
        this.$emit('on-replace', { index: this.creativeIndex, item: meta })
        timeout(0).then(() => {
          this.creativeModel = false
        })
      } else if (this.creativeType === 'large' && this.type === 'large') {
        // 大图
        this.$emit('on-replace', { index: this.creativeIndex, item: meta })
        timeout(0).then(() => {
          this.creativeModel = false
        })
      }
    }
  },
  data() {
    return {
      creativeIndex: 0,
      creativeType: 'video',
      creativeMult: null, // 是否多选
      creativeModel: null,
      creativeSmart: 0, // 当前视频id
      creativeWidth: null,
      creativeHeight: null
    }
  }
}
</script>
<style lang="scss" scoped>
.m-wrap-material {
  position: relative;
  margin-bottom: 36px;

  .box-inline {
    display: inline-block;
    line-height: 32px;

    > * {
      display: inline-block;
      vertical-align: middle;
    }

    .span-num,
    .span-sub {
      font-size: 15px;
      padding-left: 26px;
      padding-right: 26px;
      margin: 0;
    }

    .span-sub {
      color: #999;
      padding-left: 10px;
    }

    .span-idea-sub {
      padding-left: 10px;
      padding-right: 10px;
    }

    .pop-btn {
      margin-left: 26px;
      font-size: 14px;
      cursor: pointer;

      i {
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }

  .m-creative {
    padding-top: 12px;
  }

  .c-nodata {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .ivu-icon {
      display: inline-block;
    }

    span {
      color: #bebebe;
      font-size: 14px;
    }
  }
}
</style>
